import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'
import {
  Checkout,
  Grid,
  Sidebar
} from 'src/components/containers/checkout/ScreenLayout'
import ConfiguratorHelp from 'src/components/organisms/configurator/ConfiguratorHelp'
import Advantages from 'src/components/organisms/configurator/Advantages'
import CustomerReviews from 'src/components/organisms/configurator/CustomerReviews'
import Support from 'src/components/layout/Support'
import CheckOutBox from 'src/components/organisms/checkout/Confirmation'
import { StoreProps } from 'src/stores'

interface Props extends StoreProps {
  location: any
  history: any
  match: any
}

@inject('confStore')
@observer
class ConfirmationScreen extends React.Component<Props, any> {
  componentDidMount() {
    const { confStore, match, history } = this.props
    if (!confStore.isOfferLoaded)
      history.replace('/planung/abschluss/' + match.params.uuid)
  }

  render() {
    const { location } = this.props

    const metaTitle = 'Ihre Planung | Benu | Ihr moderner Bestatter'
    const metaDesc = 'Benu - Ihr moderner Bestatter ✓ Alle Bestattungsarten ✓ In ganz Österreich ✓ Persönliche Beratung ✓ Faire & Transparente Preise'
    const metaUrl = `https://www.benu.at${location.pathname}`
    const metaImg = 'http://dev.benu.at/benu_logo.png'
    return (
      <div style={{ backgroundColor: '#D5E4E6' }}>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
          <link rel='canonical' href={metaUrl} />

          <meta name='description' content={metaDesc} />
          <meta property='og:title' content={metaTitle} />
          <meta property='og:description' content={metaDesc} />
          <meta property='og:url' content={metaUrl} />
          <meta property='og:type' content='article' />
          <meta property='og:image' content={metaImg} />

          <meta name='author' content='Benu GmbH' />

          <meta name='twitter:card' content={metaImg} />
          <meta name='twitter:site' content='@benu.at' />
          <meta name='twitter:creator' content='@benu.at' />
          <meta name='twitter:title' content={metaTitle} />
          <meta name='twitter:description' content={metaDesc} />
          <meta name='twitter:image' content={metaImg} />

          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <Grid>
          <Checkout>
            <CheckOutBox />
          </Checkout>
          <Sidebar>
            <Advantages />
            <CustomerReviews />
            <ConfiguratorHelp />
          </Sidebar>
        </Grid>
        <Support />
      </div>
    )
  }
}

export default withRouter(ConfirmationScreen)



// WEBPACK FOOTER //
// ./src/screens/checkout/Confirmation.tsx